import { createStore } from 'idb-keyval';

const dbName = `${process.env.APP_NAME ?? 'storefront-app'}-db`;
const storeName = `${process.env.APP_NAME ?? 'storefront-app'}-store`;

export const keyvalStore =
  typeof window !== 'undefined' && window.indexedDB
    ? createStore(dbName, storeName)
    : undefined;
